import * as cmmn from '@utils/index';
import {logger} from "@services/logger/logger.service";
import { BaseHost } from "@core/shared/office-hosts/base-host";
import { IOfficeHost } from "@core/shared/office-hosts/office-host.types";

export class OneNoteHost extends BaseHost implements IOfficeHost
{
    public override checkSelectable() { return true; }
    public override checkDocumentReadable(): boolean { return false; }
    public override checkEditable(): boolean { return true; }

    public override async getSelectedContentAsync(): Promise<string> {
        let resultStr = '';

        const resultValue = await cmmn.callAsync<boolean>(async (r) => {
            try {
                Office.context.document.getSelectedDataAsync(
                    Office.CoercionType.Text,
                    { valueFormat: "unformatted" },
                    (asyncResult: Office.AsyncResult<string>) => {
                        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                            const error = asyncResult.error;
                            logger.error(`getSelectedContentAsync() > failed: ${error.message}`);
                            r.next(false);
                        }
                        else {
                            resultStr = asyncResult.value;
                            r.next(true);
                        }
                    }
                );
            }
            catch (err) {
                r.next(false);
            }
        });

        if (resultValue) {
            return resultStr;
        }

        return '';
    }

    public override async getDocumentIDAsync(): Promise<string> {
        return 'oneNote'
    }

    public override async setSelectedTextAsync(plainText:string): Promise<void> {
        Office.context.document.setSelectedDataAsync(
            plainText,
            {
                coercionType: Office.CoercionType.Text
            },
        );
    }
}
